import axios from 'redaxios'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ListPagination, MetricListItem } from '../utilities/customAppHelpers'
import { parseValue } from '../../../utils/useStorageState'
import { getAnalyticsList } from '../../../api/internal/analytics'

const metricConfig = {
  pdv: {
    decorator: (v: number) => {
      return v * 1000
    },
  },
  size: {
    decorator: (v: number) => {
      return v * 1024
    },
  },
  fileSize: {
    decorator: (v: number) => {
      return v * 1024
    },
  },
}

export const getDashboardAnalyticsList = (
  appId: string,
  environmentId: string,
  startDate: string,
  endDate: string,
  metrics: string,
  currentPage: number
) => {
  const token = parseValue(localStorage.getItem('token'))
  axios.defaults.headers = { ...axios.defaults.headers, Authorization: `Bearer ${token}` }

  const {
    data: analyticsList,
    isError: isGetAppStatsError,
    isLoading: isGetAppStatsLoading,
  } = useQuery({
    queryKey: ['getDashboardAnalyticsList', appId, environmentId, startDate, endDate, metrics, currentPage],
    queryFn: () => getAnalyticsList({ appId, environmentId, startDate, endDate, metrics, currentPage }),
  })

  const [analyticData, pagination]: [MetricListItem[], ListPagination] = useMemo(() => {
    if (!analyticsList?.data.data) {
      return [[], undefined]
    }

    const { data, pagination: listPagination } = analyticsList.data

    const adjustedMetricData = data.map((metric: MetricListItem) => {
      const adjustedMetric = { ...metric }

      Object.entries(metricConfig).forEach(([metricName, { decorator }]) => {
        const metricKey = metricName as keyof typeof metricConfig
        const metricValue = adjustedMetric[metricKey]
        if (metricValue) {
          adjustedMetric[metricKey] = decorator(metricValue)
        }
      })

      return adjustedMetric
    })

    return [adjustedMetricData, listPagination]
  }, [analyticsList?.data.data])

  return {
    analyticData,
    pageCount: pagination?.pageCount,
    isGetAppStatsError,
    isGetAppStatsLoading,
  }
}
